import React, { Component } from 'react';

export default class CellWrapper extends Component {
	render() {
		const { prop, cellProperties } = this.props;
		const displayDot =
			cellProperties &&
			cellProperties.overrides &&
			cellProperties.overrides.find(o => o.field === prop);

		const classes = [];
		if (displayDot) classes.push('wrapper-dot');
		if (cellProperties && cellProperties.readOnly)
			classes.push('cell-disabled');

		return <div className={classes.join(' ')}>{this.props.children}</div>;
	}
}
